import { createAsyncThunk } from '@reduxjs/toolkit';
export const spotlightContentClick = createAsyncThunk('commerce/spotlight-content/click', async (payload, { extra }) => {
    const { relay } = extra;
    const relayPayload = {
        responseId: payload.responseId,
        position: payload.position,
        itemMetadata: {
            uniqueFieldName: 'id',
            uniqueFieldValue: payload.id,
            url: payload.desktopImage,
        },
    };
    relay.emit('itemClick', relayPayload);
});
